import Factory from '@/Factories/Factory';
import ColumnFactoryTuple from '@/Factories/ColumnFactoryTuple';
import * as interfaces from '#/CoreFrameInterfaces';

/*
* Repräsentiert die Oberklasse aller ColumnFactories
*/
export default class ColumnFactory extends Factory {

    public static isPlainText = false;
    public static isJQueryElement = false;

    public tuple: ColumnFactoryTuple;

    /**
     * Das Eingabeobjekt
     */
    public raw: any;

    /**
     * Das Zeilenobjekt
     */
    public row: any;

    /**
     * Das Feld, für welches die ColumnFactory aufgerufen wird
     */
    public field: string;

    constructor(params: interfaces.IColumnFactoryConstructorParameter) {
        super(params);

        this.raw = this.paramOrDefault(params.raw, null);
        this.row = this.paramOrDefault(params.row, null);
        this.field = this.paramOrDefault(params.field, '');
        this.isDisposable = true;
    }

    /**
     * Erzeugt das FactoryTuple und die Factory
     */
    public getTuple(): ColumnFactoryTuple {
        this.tuple = new ColumnFactoryTuple(this);
        return this.tuple;
    }

    public getValue(): HTMLElement | JQuery | string {
        throw new Error('Die Funktion "getValue" wurde nicht implementiert');
    }
}